"use client";

import { useServerInsertedHTML } from "next/navigation";
import React, { useState } from "react";
import { ServerStyleSheet, StyleSheetManager } from "styled-components";

/**
 * On the server, inserts styled-component styles into the document.
 */
export const StyledComponentsRegistry = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // The order of operation is important here. we don't want compiler to optimize this file
  "use no memo";
  // Only create stylesheet once with lazy initial state
  // x-ref: https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
  const [styledComponentsStyleSheet] = useState(() => new ServerStyleSheet());

  // eslint-disable-next-line @faire/no-inline-hoc-fc -- false positive
  useServerInsertedHTML(() => {
    const elements = styledComponentsStyleSheet.getStyleElement();
    styledComponentsStyleSheet.instance.clearTag();

    return <>{elements}</>;
  });

  // eslint-disable-next-line @faire/ssr-no-restricted-globals
  if (typeof window !== "undefined") {
    return (
      <StyleSheetManager enableVendorPrefixes>{children}</StyleSheetManager>
    );
  }

  return (
    <StyleSheetManager
      enableVendorPrefixes
      sheet={styledComponentsStyleSheet.instance}
    >
      {children}
    </StyleSheetManager>
  );
};
